import workspaceQuery from 'graphql/queries/purchases/PurchaseAttributeConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/purchases/PurchaseAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/purchases/PurchaseAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/purchases/PurchaseAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/purchases/PurchaseAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/purchases/PurchaseAttributeConfigFragment.graphql';

const PurchaseAttributeConfig = {
  type: 'PurchaseAttributeConfig',
  title: 'Purchase Attributes',
  formTitle: 'Purchase Attribute',
  formUrl: '/Purchasing/AttributeConfig/Details/',
  workspaceUrl: '/Purchasing/Attribute/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'PURCHASE_ORDER_ATTRIBUTES',
};

export default PurchaseAttributeConfig;
